import { ScrollArea, Stack, Table, Text } from "@mantine/core"
import { formatCurrencyFromCents, formatDate, formatSignedCurrencyFromCents, formatTime } from "atlas_forecasting_app/lib/format"
import { RouterLink } from "atlas_forecasting_app/lib/router"

function humanizeReason(reason) {
  const normalizedReason = String(reason || "").trim()
  if (!normalizedReason) return "—"
  if (normalizedReason === "forecast") return "Forecast"
  if (normalizedReason === "add_funds") return "Add funds"
  if (normalizedReason === "refund_reversal") return "Refund reversal"
  if (normalizedReason === "dispute_withdrawal") return "Dispute withdrawal"
  if (normalizedReason === "dispute_reinstatement") return "Dispute reinstatement"

  const text = normalizedReason.replace(/_/g, " ")
  return text.charAt(0).toUpperCase() + text.slice(1)
}

function createdByLabel(createdByUser) {
  if (!createdByUser) return ""
  return createdByUser.email || `User #${createdByUser.id}`
}

function transactionTypeContent(transaction) {
  if (transaction.reason === "forecast" && transaction.forecast?.id) {
    return (
      <RouterLink className="af-balance-history-link" to={`/forecasts/${transaction.forecast.id}`}>
        Forecast
      </RouterLink>
    )
  }

  return humanizeReason(transaction.reason)
}

export function AccountBalanceHistoryTable({ transactions, emptyMessage = "No transactions yet.", showCreatedBy = false }) {
  if (!transactions.length) return <Text c="dimmed">{emptyMessage}</Text>

  return (
    <ScrollArea offsetScrollbars type="auto">
      <div className="af-balance-history-table-wrap">
        <Table className="af-balance-history-table" highlightOnHover stickyHeader stickyHeaderOffset={0} withRowBorders>
          <Table.Thead className="af-balance-history-header">
            <Table.Tr>
              <Table.Th>Transaction type</Table.Th>
              <Table.Th>Date</Table.Th>
              <Table.Th>Time</Table.Th>
              <Table.Th className="af-balance-history-numeric">Change</Table.Th>
              <Table.Th className="af-balance-history-numeric">Balance</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {transactions.map((transaction) => {
              const changeColor =
                transaction.delta_cents > 0 ? "green.7" : transaction.delta_cents < 0 ? "red.7" : undefined
              const actorLabel = showCreatedBy ? createdByLabel(transaction.created_by_user) : ""

              return (
                <Table.Tr key={transaction.id}>
                  <Table.Td className="af-balance-history-type">
                    <Stack gap={2}>
                      <Text fw={500}>{transactionTypeContent(transaction)}</Text>
                      {actorLabel ? (
                        <Text size="xs" c="dimmed">
                          by {actorLabel}
                        </Text>
                      ) : null}
                    </Stack>
                  </Table.Td>
                  <Table.Td className="af-balance-history-date">
                    <Text>{formatDate(transaction.created_at)}</Text>
                  </Table.Td>
                  <Table.Td className="af-balance-history-time">
                    <Text>{formatTime(transaction.created_at)}</Text>
                  </Table.Td>
                  <Table.Td className="af-balance-history-numeric">
                    <Text className="af-balance-history-amount" ta="right" fw={600} c={changeColor}>
                      {formatSignedCurrencyFromCents(transaction.delta_cents)}
                    </Text>
                  </Table.Td>
                  <Table.Td className="af-balance-history-numeric">
                    <Text className="af-balance-history-amount" ta="right" fw={500}>
                      {formatCurrencyFromCents(transaction.balance_after_cents)}
                    </Text>
                  </Table.Td>
                </Table.Tr>
              )
            })}
          </Table.Tbody>
        </Table>
      </div>
    </ScrollArea>
  )
}
